js_tab()
function js_tab(){
    document.addEventListener('DOMContentLoaded', initTab)
}

// inicializar initPop
function initTab() {
    const tabs = document.querySelectorAll('.js-tab-title')
    const contents = document.querySelectorAll('.js-tab-content')
    
    if ( tabs != null && contents != null ) {
        init(tabs)
    }

    function init(tabs) {
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].addEventListener('click', e => {
                e.preventDefault()
                content(tabs[i])
            })
        }
    }

    function content(tab) {
        for (let i = 0; i < contents.length; i++) {
            if (contents[i].dataset.tab == tab.dataset.tab) {
                cleanTabs()
                cleanContents()
                activeContents(tab.dataset.tab)
                activeTabs(tab.dataset.tab)
            }
        }
    }

    function cleanTabs() {
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].classList.remove('is-tab')
        }
    }

    function activeTabs(tab) {
        for (let i = 0; i < tabs.length; i++) {
            if (tabs[i].dataset.tab == tab) {
                tabs[i].classList.toggle('is-tab')
            }
        }
    }

    function cleanContents() {
        for (let i = 0; i < contents.length; i++) {
            contents[i].classList.remove('is-tab')
        }
    }

    function activeContents(tab) {
        for (let i = 0; i < contents.length; i++) {
            if (contents[i].dataset.tab == tab) {
                contents[i].classList.toggle('is-tab')
            }
        }
    }

}
